<template>
  <div :class="layoutStyle"><slot /></div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { ROUTES_WITHOUT_HEADER } from '@/apps/kiosk/constants';

/**
 * Provide layout to kiosk dark screens with centered content.
 */
@Component({
  props: {
    fullHeight: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class KioskCenteredLayout extends Vue {
  get layoutStyle() {
    const styles = [
      this.$style.centeredLayout,
    ];

    if (
      ROUTES_WITHOUT_HEADER.includes(this.$router.currentRoute.name)
      || this.fullHeight
    ) {
      styles.push(this.$style.kioskHeadless);
    } else {
      styles.push(this.$style.kioskWithHeader);
    }

    return styles;
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
$bg: rgba(0, 0, 0, 0.9);

.centeredLayout {
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $bg;
}

.kioskHeadless {
  height: 100vh;
  min-height: 1920px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/KioskCenteredLayout.vue